function getChartId(id) {
  return `chart_${id !== null && id !== void 0 ? id : ''}`;
}

export { getChartId };
